var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { any } from '@amcharts/amcharts5/.internal/core/util/Array';
import { msg } from '@lit/localize';
import { html } from 'lit';
import { customElement, property, query, state, } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { map } from 'lit/directives/map.js';
import Popup from 'devextreme/ui/popup';
import { BaseShadowless } from '../indicator/BaseShadowless';
let DinapsisMapElementLayerItem = class DinapsisMapElementLayerItem extends BaseShadowless {
    constructor() {
        super(...arguments);
        /**
         * Setting the default value of the property `overlayLayer`
         */
        this.overlayLayer = {
            id: '0', isVisible: true, name: '', selectable: true, type: 'DefaultBaseMapLayer', url: '', version: '', opacity: 1, center: false,
        };
        this.zindex = -1;
        /**
         * Setting the default value of the property `opened` to `false`.
         * Define if the panel its hiden or active
         */
        this.opened = false;
        /**
         * Setting the default value of the property `opened` to `false`.
         * Define if the panel its hiden or active
         */
        this.opacityOpened = false;
        /**
         * Setting the default value of the property `position` to up
         */
        this.position = 'up';
        /**
         * Layer opacity value
         */
        this.opacity = 100;
        /**
         * Setting the default value of the property `classes`
         * to `{ hide: true, active: false, firstrender: false }`.
         */
        this.classes = { hide: true, active: false, avoidanimation: false };
        /**
         * If we want to animate the open of the legend.
         * When drag and drop is used its value will be false in order
         * to not animate items that are already open.
         */
        this.animation = true;
        /**
         * Configuration for layer item menu
         */
        this.layerToolbarConfig = {
            showVisibility: true,
            showOpacity: true,
            showDelete: true,
        };
    }
    /**
     * The above function is a lifecycle hook that is called when the component is updated.
     */
    updated() {
        this.opacity = this.overlayLayer.opacity !== null
            && this.overlayLayer.opacity !== undefined ? this.overlayLayer.opacity * 100 : 100;
    }
    /**
     * Launch event to change visibility
     * @param ev Event
     */
    changeVisibility(ev) {
        this.dispatchEvent(new CustomEvent('change-visibility', ev));
    }
    /**
     * Launch event to change visibility
     * @param ev Event
     */
    changeVisibilityLayer(layerGroup, layerId, isVisible) {
        this.dispatchEvent(new CustomEvent('change-visibility-layer', { detail: { layerGroup, isVisible, layerId } }));
    }
    /**
     * Remove layer from layer manager.
     * @param layerId The identifier of the layer to remove.
     */
    showDeleteOverlayLayerConfirm() {
        const self = this;
        const template = `<div id="popupContainer"><p class="dinapsis-map-delete-layer-popup-title">${msg('map.confirmDeleteTitle')}</p><div><p class="dinapsis-map-delete-layer-popup-text">${msg('map.confirmDeleteText')}</p></div></div>`;
        const options = {
            contentTemplate: template,
            width: 548,
            height: 192,
            showTitle: false,
            title: 'Information',
            visible: true,
            dragEnabled: false,
            toolbarItems: [{
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    cssClass: 'dinapsis-map-delete-layer-popup-button-alternative',
                    options: {
                        text: msg('map.cancel'),
                        onClick() {
                            self.deleteLayerPopup.hide();
                        },
                    },
                }, {
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    cssClass: 'dinapsis-map-delete-layer-popup-button',
                    options: {
                        text: msg('map.accept'),
                        onClick() {
                            self.dispatchEvent(new CustomEvent('delete-overlay-layer', { detail: { layerId: self.overlayLayer.id } }));
                            self.deleteLayerPopup.hide();
                        },
                    },
                }],
            onShowing(e) {
                e.component.content().parentElement.classList.add('dinapsis-map-delete-layer-confirm-popup');
                e.component.content().parentElement.parentElement.classList.add('dinapsis-map-delete-layer-confirm-popup-overlay');
            },
        };
        // eslint-disable-next-line no-new
        this.deleteLayerPopup = new Popup(this.altertContainer, options);
        options.toolbarItems[0].options.onClick = options.toolbarItems[0]
            .options.onClick.bind(this);
        options.toolbarItems[1].options.onClick = options.toolbarItems[1]
            .options.onClick.bind(this);
    }
    /**
     * Launch event when menu option is clicker
     * @param ev Event
     */
    menuOptionClicked(ev) {
        const { optionId } = ev.detail;
        if (optionId === 'delete-layer') {
            this.showDeleteOverlayLayerConfirm();
        }
        if (optionId === 'change-opacity') {
            this.dispatchEvent(new CustomEvent('toggle-opacity', { detail: { layerId: this.overlayLayer.id, opacityOpened: !this.opacityOpened } }));
        }
        else {
            this.dispatchEvent(new CustomEvent('option-clicked', ev));
        }
    }
    /**
     * Change container state;
     */
    handleClick() {
        if (this.layerHasLegend()) {
            this.dispatchEvent(new CustomEvent('toggle-legend', { detail: { layerId: this.overlayLayer.id, open: !this.opened } }));
        }
    }
    /**
     * Handle click and dispatch center event.
     */
    handleCenter() {
        this.dispatchEvent(new CustomEvent('center-on', { detail: { layer: this.overlayLayer } }));
    }
    /**
     * Check if layer can center and return css class.
     * @returns Class center.
     */
    getCenterClass() {
        return this.overlayLayer.center ? 'center' : '';
    }
    /**
     * Show label title and subtitle
     * @returns Html that represent the component.
     */
    renderElementLayerName() {
        const title = this.overlayLayer.name.trim();
        if (this.overlayLayer.subtitle && this.overlayLayer.subtitle !== '') {
            const subtitle = this.overlayLayer.subtitle.trim();
            return html `<label
          title="${title}"
          class="container-title ${this.getCenterClass()}"
          @click="${this.handleCenter}"
        >${title}</label>
        <label title="${subtitle}" class="container-subtitle">${subtitle}</label>`;
        }
        return html `<label
        title="${title}"
        class="container-only-title ${this.getCenterClass()}"
        @click="${this.handleCenter}"
      >${title}</label>`;
    }
    /**
     * Launch when range-input or value-input change
     * @param ev Event
     */
    changeSliderValue(ev) {
        const input = ev.target;
        this.opacity = input.value === '' ? 0 : Math.round(+input.value);
        this.dispatchEvent(new CustomEvent('change-opacity', { detail: { value: (+this.opacity / 100), layerId: this.overlayLayer.id } }));
    }
    /**
     * A function that show or hide the slider-box,
     * @returns Html that represent the slider.
     */
    generateSliderBox() {
        if (this.opacityOpened) {
            return html `
      <div class="slider-container" style="${this.opened ? ' margin-bottom: 0; padding-bottom: 0;' : 'margin-bottom: 7px'}">
          <span class="container-icon">
            <span class="material-icons-arrows">opacity</span>
          </span>
          <div class="container-icon slider-content" >
          <div class="range-container">
            <input
              id="mysliderbar"
              max=100
              min=0
              step=1
              type="range"
              .value=${this.opacity ? this.opacity.toString() : '0'} 
              ?disabled=${false}
              @input=${this.changeSliderValue}
              />
          </div>
          </div>
          <div class="slider-input">
            <input type="number" id="opacity" onClick="this.select();" @input=${this.changeSliderValue} max="100" min="0" .value="${this.opacity ? Math.round(this.opacity).toString() : '0'}" >
            <span id="percent-suffix">%</span>
          </div>
          <div 
            class="slider-button"
            @click="${this.closeOpacityBox}">
            <span class="material-icon-botton">check_circle</span>
          </div>
        </div>`;
        }
        return html ``;
    }
    /**
     * This function set the container style values
     * @returns styles
     */
    getStyleContainer() {
        const marginBot = (this.opened === this.opacityOpened)
            || (this.opened && !this.opacityOpened) ? 7 : 0;
        return `
      z-index:${9100 - this.zindex};
      min-height:40px;
      margin-bottom:${marginBot}px;
      border-radius:${this.opacityOpened ? '10px 10px 0 0' : '10px'}
    `;
    }
    /**
     * CLose opacity box
     */
    closeOpacityBox() {
        this.dispatchEvent(new CustomEvent('toggle-opacity', { detail: { layerId: this.overlayLayer.id, opacityOpened: false } }));
    }
    /**
     * Show legend of all layers
     * @returns Html that represents the legend
     */
    renderElementLayerLegend() {
        let legend;
        switch (this.overlayLayer.type) {
            case 'OverlayEmptyLayer':
            case 'OverlayBasicLayer':
                legend = html `${map(this.overlayLayer.legend, (layer) => html `
              <div>
                  <span class="color-pill" style="background-color:${layer.color};"></span>
                  <label class="layer-legend">${layer.name}</label>
              </div>
          `)}
        `;
                break;
            case 'OverlayCustomLayer':
                legend = html `
        ${map(this.overlayLayer.layers, (layer) => html `
          ${map(layer.legend, (l) => html `
                <div>
                  <span class="material-icons-round dinapsis-map-icon visibility" @click=${() => this.changeVisibilityLayer(this.overlayLayer.id, layer.id, layer.isVisible)}>
                    ${layer.isVisible ? 'visibility' : 'visibility_off'}
                  </span>
                  <span class="color-pill" style="background-color:${l.color};"></span>
                  <label class="layer-legend">${l.name}</label>
                </div>
              `)}
            `)}
      `;
                break;
            default:
                legend = html ``;
                break;
        }
        return legend;
    }
    /**
     * Determine if layer has legend for enable or disable expand option.
     * @returns True if layer has layer, else false.
     */
    layerHasLegend() {
        let result = false;
        if (this.overlayLayer.type === 'OverlayBasicLayer' || this.overlayLayer.type === 'OverlayEmptyLayer') {
            const basicLayerType = this.overlayLayer;
            result = basicLayerType.legend && basicLayerType.legend.length > 0;
        }
        else if (this.overlayLayer.type === 'OverlayCustomLayer') {
            const customLayerType = this.overlayLayer;
            result = customLayerType.layers
                ? customLayerType.layers.some((el) => el.legend && el.legend.length > 0)
                : false;
        }
        return result;
    }
    /**
     * Render component
     * @returns Template of component
     */
    render() {
        if (this.opened) {
            this.classes.hide = false;
            this.classes.active = true;
            if (!this.animation) {
                this.classes.avoidanimation = true;
            }
        }
        else {
            this.classes.hide = true;
            this.classes.active = false;
            this.classes.avoidanimation = false;
        }
        return html `
      <div class="${classMap(this.classes)} dinapsis-map-element-layer-item-container" style="${this.getStyleContainer()}"  id="dinapsis-map-element-layer-item-container">
        <div class = "dinapsis-map-element-layer-item-header" id="dinapsis-map-element-layer-item-header">
          <div class="container container-order-left">
            <span class="container-icon">
                <span class="material-icons-arrows" title="${msg('map.mapDragAndDropTooltip')}">drag_indicator</span>
            </span>
            <dinapsis-map-element-layer-arrow-button
                class="container-icon"
                .position=${this.position}
                .opened=${this.opened}
                .enabled=${this.layerHasLegend()}
                @click="${this.handleClick}">
            </dinapsis-map-element-layer-arrow-button>
            &nbsp;
            <div class="container-icon">
              ${this.renderElementLayerName()}
            </div>
          </div>
          <div class="container container-order-right">
              <dinapsis-map-layer-toolbar
                layerId="${this.overlayLayer.id}"
              .isVisible="${this.overlayLayer.isVisible}"
              .layerToolbarConfig="${this.layerToolbarConfig}"
              @change-visibility="${this.changeVisibility}"
              @option-clicked="${this.menuOptionClicked}"></dinapsis-map-layer-toolbar>
          </div>
        </div>
        <div class='${classMap(this.classes)} dinapsis-map-element-layer-item-body' id="dinapsis-map-element-layer-item-body">
        ${this.overlayLayer.nameLegend
            ? html `<label title="${this.overlayLayer.nameLegend}" class="name-legend">${this.overlayLayer.nameLegend}</label>`
            : ''}
        
        ${this.renderElementLayerLegend()}
        ${!this.opened ? '' : this.generateSliderBox()}
        </div>
        
      </div>
      ${this.opened ? '' : this.generateSliderBox()}
      <div id="dinapasis-map-alert-container"></div>  
    `;
    }
};
__decorate([
    state(),
    property({ type: any })
], DinapsisMapElementLayerItem.prototype, "overlayLayer", void 0);
__decorate([
    state(),
    property({ type: Number })
], DinapsisMapElementLayerItem.prototype, "zindex", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisMapElementLayerItem.prototype, "opened", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisMapElementLayerItem.prototype, "opacityOpened", void 0);
__decorate([
    property({ type: String })
], DinapsisMapElementLayerItem.prototype, "position", void 0);
__decorate([
    state()
], DinapsisMapElementLayerItem.prototype, "opacity", void 0);
__decorate([
    property()
], DinapsisMapElementLayerItem.prototype, "classes", void 0);
__decorate([
    property()
], DinapsisMapElementLayerItem.prototype, "animation", void 0);
__decorate([
    property()
], DinapsisMapElementLayerItem.prototype, "layerToolbarConfig", void 0);
__decorate([
    query('#dinapasis-map-alert-container')
], DinapsisMapElementLayerItem.prototype, "altertContainer", void 0);
DinapsisMapElementLayerItem = __decorate([
    customElement('dinapsis-map-element-layer-item')
], DinapsisMapElementLayerItem);
export { DinapsisMapElementLayerItem };
//# sourceMappingURL=dinapsis-map-element-layer-item.js.map